import React, { useEffect, useState, useRef } from 'react'
import CaritraWidgetApi from '../../api'
import CaritraWidgetLoader from '../Loader/Loader'
import './Unit.css'
import { Button, Grid, Typography, useMediaQuery } from '@material-ui/core'
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import moment from 'moment'
import { CaritraWidgetJoinParams, CaritraWidgetCalcCurrency } from '../../utils'
import LightTooltip from '../LightTooltip/LightTooltip'


const processDates = (openings, type) => {
    const checkExists = new Set()
    const mapDateToTimes = new Map()

    if (Array.isArray(openings)) {
        openings.forEach(dateObj => checkExists.add(dateObj.dateStr))
        openings.forEach(dateObj => mapDateToTimes.set(dateObj.dateStr, (type === "Private" ? dateObj.slots : dateObj.classes).map(opening => ({ ...opening, dayOfWeek: dateObj.dayofWeek }))))
    }
    return [checkExists, mapDateToTimes]
}

const CaritraWidgetUnit = (props) => {
    const { staff, widgetInfo, option, setError, unitIndex, redirectURL } = props
    const [openings, setOpenings] = useState(null)
    const [date, setDate] = useState(null)
    const checkExists = useRef(null)
    const mapDateToTimes = useRef(null)
    const mobile = useMediaQuery(`(max-width: 37.5rem)`)

    useEffect(() => {
        let mounted = true
        const getOpenings = async () => {
            let data;
            if (widgetInfo.widgetView === "Group") {
                data = await CaritraWidgetApi.post('/api/availabilities/classes', {
                    optionId: option.optionId
                })
            }
            else if (widgetInfo.widgetView === "Private" && staff) {
                data = await CaritraWidgetApi.post('/api/availabilities/slots', {
                    optionId: option.optionId,
                    staffId: staff.staffId
                })
            }
            else {
                setError("Widget data is corrupt. Please contact Caritra")
            }
            if (data && data.error) {
                if (mounted) {
                    setOpenings([])
                }
            }
            else if (data) {
                if (widgetInfo.widgetView === "Private") {
                    const helperData = processDates(data.slotDetails, 'Private')
                    checkExists.current = helperData[0]
                    mapDateToTimes.current = helperData[1]
                    if (mounted) {
                        setDate(data.slotDetails.length > 0 ? moment(data.slotDetails[0].dateStr, "MMM, Do YYYY") : null)
                        setOpenings({ list: data.slotDetails })
                    }


                }
                else if (widgetInfo.widgetView === "Group") {
                    const helperData = processDates(data.classDetails, 'Group')
                    checkExists.current = helperData[0]
                    mapDateToTimes.current = helperData[1]
                    if (mounted) {
                        setDate(data.classDetails.length > 0 ? moment(data.classDetails[0].dateStr, "MMM, Do YYYY") : null)
                        setOpenings({ list: data.classDetails, timeZone: data.timeZone })
                    }

                }
            }
            else {
                setError("Openings could not be retrieved. Please contact Caritra")
            }
        }
        getOpenings()
        return () => { mounted = false }
    }, [option.optionId, setError, staff, widgetInfo.widgetView])



    if (openings !== null) {
        if (Array.isArray(openings.list) && openings.list.length > 0 && date !== null) {
            return (
                <div className="CaritraWidgetUnitWrapper">
                    <Grid container alignItems="center">
                        <Grid item xs={mobile ? 12 : 4}>
                            <div className="CaritraWidgetUnitInfoContainer">
                                <LightTooltip arrow title={option.name}>
                                    <Typography className="CaritraWidgetUnitTitle" noWrap>
                                        {option.name}
                                    </Typography>
                                </LightTooltip>
                                <Typography className="CaritraWidgetUnitText" noWrap>
                                    1 Session
                                </Typography>
                            </div>

                        </Grid>
                        <Grid item xs={mobile ? 12 : 4} className="CaritraWidgetUnitSectionContainer">
                            <div className="CaritraWidgetUnitPricingContainer">
                                <LightTooltip arrow title={CaritraWidgetCalcCurrency(option.price, widgetInfo.currencyInfo)}>
                                    <Typography className="CaritraWidgetUnitPrice" noWrap color="primary" align={mobile ? "left" : "center"}>
                                        {CaritraWidgetCalcCurrency(option.price, widgetInfo.currencyInfo)}
                                    </Typography>
                                </LightTooltip>
                                {
                                    option.discounts && option.discounts.length > 0 ?
                                        <Typography align={mobile ? "left" : "center"}>
                                            <b>Applicable Discount(s)</b>
                                        </Typography>
                                        : null
                                }
                                <div className="CaritraWidgetUnitDiscountContainer">
                                    <div className="CaritraWidgetUnitDiscountName">
                                        {option.discounts.map((discount, index) => (
                                            <LightTooltip arrow title={discount.name} key={`unit_${unitIndex}_${staff ? staff.firstName + "_" + staff.lastName : ""}_discount_name_${index}`}>
                                                <Typography noWrap>
                                                    {discount.name}
                                                </Typography>
                                            </LightTooltip>

                                        ))}
                                    </div>
                                    <div className="CaritraWidgetUnitDiscountAmount">
                                        {option.discounts.map((discount, index) => (
                                            <Typography align="right" key={`unit_${unitIndex}_${staff ? staff.firstName + "_" + staff.lastName : ""}_discount_amount_${index}`} noWrap>
                                                {discount.percentage}%
                                            </Typography>))}
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item xs={mobile ? 12 : 6} className="CaritraWidgetUnitContainer" style={{ color: widgetInfo.widgetColor.textColor }}>
                            <div className="CaritraWidgetUnitCalendarContainer">
                                <MuiPickersUtilsProvider utils={MomentUtils} libInstance={moment}>
                                    <DatePicker

                                        disableToolbar
                                        views={["date"]}
                                        orientation="portrait"
                                        variant="static"
                                        openTo="date"
                                        disablePast={true}
                                        value={date}
                                        onChange={(value) => {
                                            setDate(value)
                                        }}
                                        shouldDisableDate={(day) => { return !(checkExists.current).has(day.format("MMM, Do YYYY")) }}
                                        {...props.moreProps}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </Grid>
                        <Grid item xs={mobile ? 12 : 6} className="CaritraWidgetUnitAvailable">
                            {mapDateToTimes.current.get(date.format("MMM, Do YYYY")).map((availability, index) => (
                                <UnitChoice
                                    key={`unit_${unitIndex}_availibility_${index}_${staff ? staff.firstName + "_" + staff.lastName : ""}`}
                                    {...{ date, widgetInfo, staff, availability, option, redirectURL }}

                                />
                            ))}
                        </Grid>
                    </Grid>
                </div>
            )
        }
        else {
            return null
        }
    }
    else {
        return (
            <div className="CaritraWidgetUnitContainer">
                <CaritraWidgetLoader height="22.5rem" width="100%" />
            </div>
        )
    }
}

const getDateStr = (payload, type) => {
    if (type === "Group") {
        return `${payload.availability.dayOfWeek}, ${payload.date.format("MMM D")} ${payload.availability.time.toUpperCase()}`
    }
    else if (type === "Private") {
        return `${payload.availability.dayOfWeek}, ${moment.utc(payload.availability.utcDate).format("MMM D")} ${payload.availability.time.toUpperCase()}`
    }
}



const UnitChoice = (props) => {
    const { availability, widgetInfo, date, staff, option, redirectURL } = props
    const converted_date = getDateStr({ availability, date }, widgetInfo.widgetView)
    const option_data = {
        ...(widgetInfo.widgetView === "Private" ? { staffId: staff.staffId, utcDate: availability.utcDate } : { classId: availability.classId }),
        optionId: option.optionId,
        dateTime: converted_date,

    }

    return (
        <React.Fragment>
            <Grid container alignItems="center" className="CaritraWidgetUnitChoiceContainer">
                <Grid item className="CaritraWidgetUnitChoiceTextContainer">
                    <LightTooltip arrow title={converted_date}>
                        <Typography className="CaritraWidgetUnitTitle" noWrap>
                            {converted_date}
                        </Typography>
                    </LightTooltip>
                </Grid>
                <Grid item className="CaritraWidgetUnitChoiceButtonContainer">
                    {option.soldOut ?
                        <Button
                            className="CaritraWidgetPackPassButton"
                            variant="contained"
                            color="primary"
                            disabled
                        >
                            <Typography className="CaritraWidgetPackPassButtonText" color="secondary" noWrap>
                                Sold Out
                            </Typography>
                        </Button>

                        :
                        <a href={`${redirectURL}/${widgetInfo.offeringId}?${CaritraWidgetJoinParams(option_data)}`} rel="noopener noreferrer" target="_blank" className="CaritraWidgetPackPassButtonText">
                            <Button
                                className="CaritraWidgetPackPassButton"
                                variant="contained"
                                color="primary"
                                disabled={option.soldOut}
                            >
                                <Typography className="CaritraWidgetPackPassButtonText" color="secondary" noWrap>
                                    Purchase
                                </Typography>
                            </Button>
                        </a>
                    }
                </Grid>
            </Grid>
            <div style={{ height: "1.25rem" }} />
        </React.Fragment>
    )
}

export default CaritraWidgetUnit